import useStyles, {
    StepNumber,
} from "./styles"
import { Subtitle2 } from "components/shareable/Typography"
import Colors from "modules/Colors"
import { ReactComponent as CheckedIcon } from "assets/images/tick-white.svg"
import { useTheme } from "@material-ui/core"
import ErrorBanner from "../AdvancedSettingsTab/Components/ErrorBanner"
import useScreen from "Hooks/useScreen"
import ButtonSymphony from "elements/ButtonSymphony"
import TagSymphony from "elements/TagSymphony"
import CardSymphony from "elements/CardSymphony"
import { clsx, styx } from "modules/Utils"
import Sty from "modules/Sty"

interface ConversionsConfigStepProps {
    className?: string
    title: string
    completedTitle?: string
    description: string
    stepNumber?: number
    children: JSX.Element
    isSuccessful: boolean
    errorTitle?: string
    errorDescription?: string
    isCompleted: boolean
    showErrorView?: boolean
    hideErrorBanner?: boolean
    buttonText: string
    intercomButtonText?: string | null
    disabled?: boolean
    retriedText?: string
    showIntercomButton?: boolean
    live?: boolean
    onSkipError?: () => void
    onHover?: () => void
    onClickHowToLinkButton?: () => void
    onClickErrorButton?: () => void
    onClickIntercomButton?: () => void
}

const ConversionsConfigStep = ({
    className = '',
    title,
    completedTitle,
    description,
    stepNumber,
    children,
    isSuccessful,
    errorTitle,
    errorDescription,
    isCompleted,
    showErrorView,
    hideErrorBanner,
    buttonText,
    intercomButtonText = 'Watch video',
    disabled,
    retriedText,
    showIntercomButton,
    live,
    onSkipError,
    onHover,
    onClickHowToLinkButton,
    onClickErrorButton,
    onClickIntercomButton,
}: ConversionsConfigStepProps) => {
    const theme = useTheme()
    const classes = useStyles(theme)
    const { mobileView } = useScreen()

    const renderHeader = () => {
        return (
            <div
                className="headerContainerConversionsConfigStep"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                {stepNumber &&
                    <StepNumber
                        background={isCompleted ? Colors.green : Colors.PAPER_ACCENT_CONTAINER}
                    >
                        {isCompleted ?
                            <CheckedIcon
                                className={classes.svgChecked}
                            />
                            :
                            <Subtitle2 color={Colors.purple}>
                                {String(stepNumber)}
                            </Subtitle2>
                        }
                    </StepNumber>
                }
                <div style={Sty.text16bold}>
                    {isCompleted && completedTitle ?
                        completedTitle
                        :
                        title
                    }
                </div>
                {live &&
                    <TagSymphony
                        className="liveTag"
                        color="green"
                        title="LIVE"
                    />
                }
            </div>
        )
    }

    return (
        <CardSymphony
            className={clsx('conversionsConfigStepComponent', className)}
            style={styx(
                {
                    pointerEvents: disabled ? "none" : undefined,
                    filter: disabled ? "saturate(0)" : undefined,
                    opacity: disabled ? 0.4 : 1,
                },
            )}
            isPadding16
        >
            <div
                onMouseOver={onHover}
            >
                {renderHeader()}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        paddingLeft: stepNumber ? '32px' : '0px',
                        gap: 16,
                        width: '100%',
                    }}
                >
                    <div style={Sty.text16grey}>
                        {description}
                    </div>
                    {intercomButtonText && ((mobileView && onClickIntercomButton) || showIntercomButton) &&
                        <ButtonSymphony
                            className="watchVideoButton"
                            onClick={onClickIntercomButton}
                            variant="text"
                        >
                            {intercomButtonText}
                        </ButtonSymphony>
                    }
                    {children}
                    {!isSuccessful && !hideErrorBanner &&
                        <ErrorBanner
                            errorDescription={errorDescription}
                            errorTitle={errorTitle}
                            showErrorView={showErrorView}
                            onClickErrorButton={onClickErrorButton}
                            onClickHowToLinkButton={onClickHowToLinkButton}
                            buttonText={buttonText}
                            retriedText={retriedText}
                            onSkipError={onSkipError}
                        />
                    }
                </div>
            </div>
        </CardSymphony>
    )
}

export default ConversionsConfigStep
